import { SharedModule } from './shared/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomePageComponent } from './home-page/home-page.component';

import { environment } from 'src/environments/environment';

import { initializeApp } from 'firebase/app';
import { Firestore, getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
//import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
//import { /*enableIndexedDbPersistence,*/ getFirestore, provideFirestore } from '@angular/fire/firestore';
//import { FIREBASE_OPTIONS } from '@angular/fire/compat';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptorService } from './services/authentication/auth-interceptor.service';
import { OfflinePageComponent } from './offline-page/offline-page.component';
//import { HashLocationStrategy, LocationStrategy } from '@angular/common';
//import { getStorage, provideStorage } from '@angular/fire/storage';

const firebaseApp = initializeApp(environment.firebase);
//const firestore = getFirestore(firebaseApp);
//const storage = getStorage(firebaseApp);

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    OfflinePageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,

    /*provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideFirestore(() => {
            const firestore = getFirestore();
            //connectFirestoreEmulator(firestore, 'localhost', 8080);
            //enableIndexedDbPersistence(firestore);
            return firestore;
        }), provideStorage(() => getStorage()),*/


   /* // v 6
    AngularFireModule.initializeApp(environment.firebase),
    //AngularFirestoreModule.enablePersistence(),
    AngularFirestoreModule,
    AngularFireAuthModule,*/



    DragDropModule,
    HttpClientModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    //{ provide: 'asd', useValue: firestore },
    //{ provide: 'STORAGE', useValue: storage }
    //,
    //{ provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    // tentar comentar ao fazer deploy
    //{provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
